import { get } from 'lodash';
import { asCurrency } from 'src/utilities';
import InteractsWithState from 'mixins/InteractsWithState';
import PriceModifier from 'components/PriceModifier';

export default {
  mixins: [InteractsWithState],

  props: ['facet'],

  data() {
    return {
      valid: true,
    };
  },

  computed: {
    choices() {
      return get(this.facet, 'choices.data', []).map(c => ({
        ...c,
        price: asCurrency(c.srp_amount),
      }));
    },
  },

  components: { PriceModifier },
};



// WEBPACK FOOTER //
// ./src/mixins/ActsAsFacet.js